var map = {
	"./blank stare 2022.webp": 2274,
	"./brody dalle 2022.webp": 37,
	"./daze 2023.webp": 5266,
	"./failure 2023.webp": 2380,
	"./motion 2020.webp": 1871,
	"./oranges 2022.webp": 1736,
	"./scatter brain 2023.webp": 9308,
	"./self portrait 2020.webp": 124,
	"./self portrait 2022.webp": 1726,
	"./surface study 2023.webp": 3568,
	"./untitled study 2022.webp": 9007,
	"./void 2022.webp": 5061,
	"./was it ever real 2023.webp": 942
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4245;